import React, {useState} from "react";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Link } from "react-router-dom";
import { auth } from "../../../firebase";
import SocialSignin from './social-signin';
import { FaExclamationCircle } from 'react-icons/fa';
import * as Actions from '../../../redux/actions/';
import './auth.scss';

const SignIn = ({ setIsAuthenticating }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

	const signInWithEmailAndPasswordHandler = (event, email, password) => {
		event.preventDefault();
		setIsAuthenticating(true);
		auth.signInWithEmailAndPassword(email, password).catch(error => {
			setError("Signin failed. Email or password is incorrect.");
		});
	};

  const onChangeHandler = (event) => {
    const {name, value} = event.currentTarget;

    if(name === 'userEmail') {
        setEmail(value);
    }
    else if(name === 'userPassword'){
      setPassword(value);
    }
  };

  return (
		<>
			<div className="auth-heading">
				<h1>Sign In</h1>
				{ error && <div className="auth-notification"><span className="error-icon"><FaExclamationCircle /></span>{error}</div> }
			</div>
			<div className="form-element">
				<h2><label htmlFor="userEmail" className="block">Email:</label></h2>
				<div className="input-wrap">
					<input
			            type="email"
			            name="userEmail"
			            value={email}
			            id="userEmail"
			            onChange={event => onChangeHandler(event)}
			        />
				</div>
			</div>
			<div className="form-element">
				<h2><label htmlFor="userPassword" className="block">Password:</label></h2>
				<div className="input-wrap">
					<input
						autoComplete="off"
						type="password"
						name="userPassword"
						value={password}
						id="userPassword"
						onChange={event => onChangeHandler(event)}
					/>
				</div>
			</div>
			<button className="primary" onClick = {(event) => {signInWithEmailAndPasswordHandler(event, email, password)}}>
				Sign in
			</button>
			<div className="auth-supplemental">
		        <SocialSignin />
		        <p> Don't have an account?{" "}<Link to="/signup">Sign up here</Link>{" "}</p>
		        <p><Link to="/password-reset">Forgot Password?</Link></p>
			</div>
    </>
  );
};

const mapStateToProps = state => {
  return {
		isAuthenticating: state.isAuthenticating
  }
}

const mapDispatchToProps = {
	setIsAuthenticating: Actions.setIsAuthenticating
};

export default compose(
	connect(mapStateToProps, mapDispatchToProps)
)(SignIn);
